import { inject, Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { firstValueFrom } from 'rxjs';

import { CurrentConfigurationsService } from './current-configuration.service';
import { PushSubscriptionsApi } from '@api/backend-connector/services';

const getExistingSubscription = async (): Promise<PushSubscription | null> => {
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
};

const extractSubInfo = (sub: PushSubscription) => {
  const data = sub.toJSON();
  const endpoint = data.endpoint;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const keys = data.keys as any;
  const p256DH = keys?.p256dh;
  const auth = keys?.auth;
  return {
    data,
    endpoint,
    p256DH,
    auth,
  };
};

@Injectable({ providedIn: 'root' })
export class SwPushService {
  public swPush = inject(SwPush);
  public pushSubscriptionsApi = inject(PushSubscriptionsApi);
  public currentConfigurationsService = inject(CurrentConfigurationsService);

  constructor() {
    this.swPush.messages.subscribe((msg) => {
      // eslint-disable-next-line no-console
      console.log('Messaggio push ricevuto:', msg);
    });
    this.swPush.notificationClicks.subscribe(({ action, notification }) => {
      // eslint-disable-next-line no-console
      console.log('Notifica cliccata:', notification);
      // eslint-disable-next-line no-console
      console.log('Notifica cliccata action:', action);
    });
  }

  async subscribeToNotifications() {
    if (!this.swPush.isEnabled) return;

    const existingSub = await getExistingSubscription();
    if (existingSub) {
      const { p256DH, auth } = extractSubInfo(existingSub);
      const userSubs = await firstValueFrom(this.pushSubscriptionsApi.listPushSubscription());

      const stillValid = userSubs.find((sub) => sub.auth === auth && sub.p256DH == p256DH);
      if (stillValid) {
        return;
      } else {
        await existingSub.unsubscribe();
      }
    }

    try {
      const publicKey = await firstValueFrom(this.currentConfigurationsService.pushNotificationsPublicKey());
      if (!publicKey) {
        return;
      }
      const sub = await this.swPush.requestSubscription({
        serverPublicKey: publicKey,
      });

      const { data, endpoint, p256DH, auth } = extractSubInfo(sub);

      if (endpoint && p256DH && auth) {
        await firstValueFrom(
          this.pushSubscriptionsApi.createPushSubscription({
            body: {
              endpoint,
              auth,
              p256DH,
            },
          }),
        );
      } else {
        console.error('Impossibile registrare la sottoscrizione, dati mancanti', data);
      }
    } catch (err) {
      console.error('Impossibile iscrivere utente', err);
    }
  }
}
